import { render, staticRenderFns } from "./TermAndAgreement.vue?vue&type=template&id=016b7d75"
import script from "./TermAndAgreement.vue?vue&type=script&lang=js"
export * from "./TermAndAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports